import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Navigation from './Navigation';
import config from '../config';

const VerifyEmail = () => {
  const [status, setStatus] = useState('verifying');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const token = new URLSearchParams(location.search).get('token');

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        setStatus('verifying');
        
        const response = await fetch(`${config.apiUrl}/api/verify-email?token=${token}`);
        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.error || 'Verification failed');
        }

        // Check if we got a checkout URL for subscription flow
        if (data.checkoutUrl) {
          console.log('Got checkout URL:', data.checkoutUrl);
          setStatus('success');
          setTimeout(() => {
            window.location.href = data.checkoutUrl;
          }, 2000);
          return;
        }

        // Handle successful verification (non-subscription flow)
        setStatus('success');
        setTimeout(() => {
          navigate('/login?verified=true');
        }, 3000);
      } catch (err) {
        console.error('Verification error:', err);
        setError(err.message || 'An error occurred during verification');
        setStatus('error');
      }
    };

    if (token) {
      verifyEmail();
    } else {
      setError('No verification token provided');
      setStatus('error');
    }
  }, [token, navigate, setUser]);

  return (
    <div className="page-container">
      <Navigation />
      <main className="main-content">
        <div className="container">
          <h1 className="page-title heading-2">Email Verification</h1>
          {status === 'verifying' && (
            <div className="info-message">
              <div className="loading-spinner"></div>
              <p>Verifying your email address...</p>
            </div>
          )}
          {status === 'success' && (
            <div className="success-message">
              <div className="loading-spinner"></div>
              <p>Email verified successfully! Redirecting to checkout...</p>
            </div>
          )}
          {status === 'error' && (
            <div className="error-message">
              <p>{error}</p>
              <button 
                className="button button-primary"
                onClick={() => navigate('/pricing')}
              >
                Back to Pricing
              </button>
            </div>
          )}
        </div>
      </main>
    </div>
  );
};

export default VerifyEmail;
